import { useEffect, useRef } from "react";
import "./ConfirmDialog.css";

export default function ConfirmDialog({
  open,
  title,
  body,
  confirmLabel,
  dismissLabel,
  variant = "danger", // "danger" | "default"
  loading = false,
  onConfirm,
  onDismiss,
}) {
  const dismissRef = useRef(null);

  // Focus dismiss button when dialog opens (it's the "safe" action)
  useEffect(() => {
    if (open && dismissRef.current) {
      dismissRef.current.focus();
    }
  }, [open]);

  // Close on Escape key
  useEffect(() => {
    if (!open) return;
    const handleKey = (e) => {
      if (e.key === "Escape" && !loading) onDismiss();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [open, loading, onDismiss]);

  if (!open) return null;

  return (
    <div className="cd-overlay" onClick={loading ? undefined : onDismiss}>
      <div className="cd-dialog" role="alertdialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        {title && <h3 className="cd-title">{title}</h3>}
        {body && (
          typeof body === "string"
            ? <p className="cd-body">{body}</p>
            : <div className="cd-body">{body}</div>
        )}
        <div className="cd-actions">
          <button
            ref={dismissRef}
            className="btn-primary btn-sm"
            onClick={onDismiss}
            disabled={loading}
          >
            {dismissLabel}
          </button>
          <button
            className={`btn-sm ${variant === "danger" ? "btn-danger" : "btn-ghost"}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? <span className="btn-spinner" /> : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
